import React from 'react';

const HairlineDivider = ({ className = '' }) => (
  <div
    role="separator"
    className={`h-px bg-hairline my-12 ${className}`.trim()}
  />
);

export default HairlineDivider;
